var map = {
	"./amazon-music.svg": 5661,
	"./applemusic.svg": 4128,
	"./deezer.svg": 4610,
	"./instagram.svg": 8667,
	"./spotify.svg": 4741,
	"./youtube.svg": 2205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7989;